import { useI18n } from '../../i18n';
import { useGameData } from '../../state/game';
import { BottleCap } from '../app/BottleCap';
import { computeStandings } from '../../lib/standings';
import { localizedName } from '../../lib/static';

/** 12 group standings tables computed client-side from finished matches. */
export function GroupsView() {
  const { t, locale } = useI18n();
  const { bundle } = useGameData();
  if (!bundle) return null;

  const groupCodes = Object.keys(bundle.groups).sort();

  return (
    <div class="groups">
      {groupCodes.map((g) => {
        const teamCodes = bundle.groups[g];
        const groupMatches = bundle.matches.filter((m) => m.group === g);
        const rows = computeStandings(teamCodes, groupMatches);
        return (
          <div key={g} class="bc-card group">
            <div class="group__head">
              <span class="bc-label">{t('groups.group')} {g}</span>
              <span class="group__cols">
                <span>{t('groups.col_p')}</span>
                <span>{t('groups.col_gd')}</span>
                <span>{t('groups.col_pts')}</span>
              </span>
            </div>
            {rows.map((r, i) => {
              const team = bundle.teams[r.code];
              return (
                <div key={r.code} class={`group__row${i < 2 ? ' is-through' : ''}`}>
                  <span class="group__rank">{i + 1}</span>
                  <BottleCap flag={team?.flag} code={r.code} size={24} />
                  <span class="group__name">{team ? localizedName(team.name, locale) : r.code}</span>
                  <span class="group__num">{r.played}</span>
                  <span class="group__num">{r.gd > 0 ? `+${r.gd}` : r.gd}</span>
                  <span class="group__pts">{r.pts}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
